// Season / format cluster — sezónní a formátové stránky s reálnými provozními rozdíly.
import { mkIntent } from "./intents";

export const FORMATS = [
  mkIntent({
    slug: "jarni-teambuilding",
    breadcrumb: "Jarní teambuilding",
    overline: "JARNÍ TEAMBUILDING",
    title: "Jarní teambuilding na Ještědu | Mission Ještěd duben–červen",
    description: "Jarní firemní teambuilding na Ještědu: mise v probouzející se přírodě, proměnlivé počasí s weather planem, soukromá Warehouse party. Duben–červen.",
    h1: "Jarní teambuilding: hora se probouzí a váš tým s ní",
    heroSub: "Duben až červen je ideální sezóna: svěží les, dlouhé dny, míň lidí na trasách. Jarní počasí je proměnlivé — proto má každá mise weather plan.",
    img: "forestMission",
    answerQ: "Jak probíhá jarní teambuilding na Ještědu?",
    answerShort: "Stejně jako v jiné sezóně: briefing ve Warehouse, drop na start, mise s checkpointy, finish na Ještědu a večer soukromá party. Jaro znamená hlavně proměnlivé počasí — trasa má varianty a kryté checkpointy.",
    answerDetail: [
      "Na jaře (duben–červen) doporučujeme vrstvené oblečení a nepromokavou bundu — ráno bývá pod 10 °C, odpoledne klidně 20 °C.",
      "Jarní termíny mají nejlepší dostupnost v roce — ve všední dny umíme akci připravit i se 3–4týdenní lhůtou.",
    ],
    sections: [
      {
        kicker: "POČASÍ",
        heading: "Jaro je loterie — my ji vyhráváme plánem B",
        paras: [
          "Předpověď sledujeme 5 dní před akcí a konfiguraci trasy potvrzujeme 24–48 hodin před startem. Déšť misi nevadí — kryté checkpointy a zkrácené varianty jsou připravené.",
          "Rozmrzlé lesní cesty znamenají jediné: pevná obuv je povinnost. Před akcí rozešleme checklist vybavení.",
        ],
        img: "qrCheckpoint",
      },
      {
        kicker: "VÝHODY JARA",
        heading: "Proč jaro zvolit",
        list: [
          "Nejdelší denní světlo v kombinaci s mírným počasím",
          "Prázdnější trasy než v létě",
          "Nejlepší dostupnost termínů v roce",
          "Ideální teploty pro fyzickou aktivitu",
        ],
        paras: [],
      },
    ],
    faq: [
      { q: "Co když na jaře prší?", a: "Mise se neruší. Weather plan nabízí zkrácenou trasu s krytými checkpointy, indoor+outdoor mix nebo v krajním případě indoor backup ve Warehouse." },
      { q: "Jaké oblečení na jarní misi?", a: "Vrstvené oblečení, nepromokavá bunda a pevná obuv. Konkrétní checklist podle předpovědi rozešleme před akcí všem účastníkům." },
      { q: "Kdy poptat jarní termín?", a: "Jaro má nejlepší dostupnost — 3–4 týdny předem obvykle stačí. Květnové pátky ale mizí rychle." },
    ],
    related: [
      { href: "/pruvodce/co-si-vzit-na-outdoor-teambuilding", title: "Co si vzít", text: "Checklist vybavení podle sezóny." },
      { href: "/pruvodce/teambuilding-kdyz-prsi", title: "Teambuilding, když prší", text: "Jak funguje weather plan." },
      { href: "/letni-teambuilding", title: "Letní teambuilding", text: "Červenec a srpen na Ještědu." },
      { href: "/mission-jested", title: "Mission Ještěd", text: "Kompletní program mise." },
    ],
  }),
  mkIntent({
    slug: "letni-teambuilding",
    breadcrumb: "Letní teambuilding",
    overline: "LETNÍ TEAMBUILDING",
    title: "Letní teambuilding na Ještědu | Mission Ještěd červenec–srpen",
    description: "Letní firemní teambuilding na Ještědu: horské klima místo městského vedra, mise s checkpointy, finish drink na vrcholu a Warehouse party. Červenec–srpen.",
    h1: "Letní teambuilding: z vedra kanceláře na horský hřeben",
    heroSub: "Na Ještědu je v létě o 8–10 °C míň než v Praze. Mise v lesním stínu, finish drink na vrcholu, večer venkovní atmosféra u Warehouse.",
    img: "summit",
    answerQ: "Jak probíhá letní teambuilding na Ještědu?",
    answerShort: "Letní mise běží ve stejném schématu — briefing, drop, checkpointy, finish, party. V létě hlídáme hlavně hydrataci a odpolední bouřky; start a tempo trasy přizpůsobíme předpovědi.",
    answerDetail: [
      "Doporučené vybavení: kšiltovka, opalovací krém a minimálně 1 litr vody na osobu. Trasa vede převážně lesním stínem.",
      "Léto má nejdelší denní světlo — večerní program ve Warehouse může začít venkovním posezením.",
    ],
    sections: [
      {
        kicker: "HORKO A BOUŘKY",
        heading: "Letní specifika, která hlídáme",
        paras: [
          "Odpolední bouřky jsou v létě v horách jediné reálné riziko. Předpověď radarů sledujeme v den akce a při výhledu bouřek trasu zkrátíme nebo přesuneme do lesa mimo hřeben.",
          "Při tropických dnech přidáváme na checkpointy vodu a zkracujeme exponované úseky trasy.",
        ],
        img: "finishDrink",
      },
      {
        kicker: "LETNÍ VEČER",
        heading: "Party, která začíná venku",
        paras: [
          "Letní večery u Warehouse mají atmosféru, kterou v zimě nezažijete — večeře a drinky venku, pak DJ a klub uvnitř do 02:00.",
          "Letní pátky jsou nejžádanější termíny roku — doporučujeme poptat 6–8 týdnů předem.",
        ],
      },
    ],
    faq: [
      { q: "Není na misi v létě vedro?", a: "Na Ještědu bývá o 8–10 °C méně než v nížině a trasa vede lesem. Při tropických dnech upravujeme tempo a přidáváme vodu na checkpointy." },
      { q: "Co když přijde bouřka?", a: "Bouřkový radar sledujeme v den akce. Při riziku trasu zkrátíme nebo přesuneme mimo hřeben. Bezpečnost má přednost před dramaturgií." },
      { q: "Jaké jsou letní kapacity?", a: "Léto je sezóna — páteční termíny doporučujeme poptat 6–8 týdnů předem, všední dny mívají volno i na kratší lhůty." },
    ],
    related: [
      { href: "/podzimni-teambuilding", title: "Podzimní teambuilding", text: "Mlha a barvy Ještědu." },
      { href: "/pruvodce/co-si-vzit-na-outdoor-teambuilding", title: "Co si vzít", text: "Checklist vybavení." },
      { href: "/teambuilding-s-party", title: "Teambuilding s party", text: "Mise + soukromý klub." },
      { href: "/mission-jested", title: "Mission Ještěd", text: "Kompletní program mise." },
    ],
  }),
  mkIntent({
    slug: "podzimni-teambuilding",
    breadcrumb: "Podzimní teambuilding",
    overline: "PODZIMNÍ TEAMBUILDING",
    title: "Podzimní teambuilding na Ještědu | Mission Ještěd září–listopad",
    description: "Podzimní firemní teambuilding na Ještědu: mlha, barvy a nejsilnější atmosféra mise. Ideální předvánoční termín — poptávejte 6–8 týdnů předem.",
    h1: "Podzimní teambuilding: mlha na hřebeni, nejsilnější atmosféra roku",
    heroSub: "Září až listopad. Les hraje barvami, mlha dává misi filmový ráz a večer ve Warehouse je o to útulnější. Náš nejoblíbenější čas na mise.",
    img: "forestMission",
    answerQ: "Proč podzim na teambuilding na Ještědu?",
    answerShort: "Podzim nabízí nejlepší kombinaci: stabilní počasí bez horka, dramatickou atmosféru mlhy a barev a ideální načasování před vánočním shonem firmy. Je to zároveň nejžádanější sezóna — poptávejte 6–8 týdnů předem.",
    answerDetail: [
      "Fotografie z podzimních misí mají atmosféru, kterou léto nenahradí — mlha mezi stromy a barevný hřeben.",
      "Kratší dny řešíme dřívějším startem mise, takže finish na Ještědu stíháte za světla.",
    ],
    sections: [
      {
        kicker: "PŘEDVÁNOČNÍ SEZÓNA",
        heading: "Podzim = nejžádanější termíny",
        paras: [
          "Většina firem chce teambuilding v říjnu a listopadu — před vánočními večírky a uzávěrkami. Kapacita Warehouse je jedna firma na večer, takže termíny mizí rychle.",
          "Doporučujeme poptat 6–8 týdnů předem. Všední dny mají lepší dostupnost než pátky.",
        ],
        img: "warehouseParty",
      },
      {
        kicker: "VYBAVENÍ",
        heading: "Co na podzimní misi",
        paras: [
          "Nepromokavá bunda, vrstvené oblečení, tenké rukavice a čepice do batohu. Podzimní Ještěd umí mlhu, vítr i slunce v jediném odpoledni.",
          "Detailní checklist podle předpovědi rozešleme účastníkům před akcí.",
        ],
      },
    ],
    faq: [
      { q: "Není na podzim zima?", a: "Na hřebeni bývá 5–12 °C. Pohyb zahřeje a večer čeká vyhřátý Warehouse. Vrstvení je klíč — checklist pošleme předem." },
      { q: "Stíháme finish za světla?", a: "Ano. V říjnu a listopadu posouváme start mise dřív, takže finish na Ještědu je vždy za denního světla." },
      { q: "Jak daleko předem poptat podzimní termín?", a: "6–8 týdnů, u pátků ideálně víc. Podzim je nejprodávanější sezóna." },
    ],
    related: [
      { href: "/zimni-teambuilding", title: "Zimní teambuilding", text: "Zimní varianta mise." },
      { href: "/teambuilding-s-vecernim-programem", title: "Večerní program", text: "Večeře, vyhlášení, party." },
      { href: "/cenik", title: "Ceník", text: "Balíčky a orientační ceny." },
      { href: "/mission-jested", title: "Mission Ještěd", text: "Kompletní program mise." },
    ],
  }),
  mkIntent({
    slug: "zimni-teambuilding",
    breadcrumb: "Zimní teambuilding",
    overline: "ZIMNÍ TEAMBUILDING",
    title: "Zimní teambuilding na Ještědu | Mission Ještěd prosinec–březen",
    description: "Zimní firemní teambuilding na Ještědu: kratší outdoorová mise ve sněhu, delší večerní program ve vyhřátém Warehouse. Weather plan a indoor backup.",
    h1: "Zimní teambuilding: sníh na Ještědu, teplo ve Warehouse",
    heroSub: "Zimní mise má kratší outdoorovou část a delší večerní program. Sníh dává checkpointům jinou obtížnost — a Warehouse party jinou atmosféru.",
    img: "warehouseExterior",
    answerQ: "Funguje Mission Ještěd i v zimě?",
    answerShort: "Ano. Zimní varianta (prosinec–březen) má kratší a méně exponovanou trasu, upravené checkpointy a delší program ve Warehouse. Extrémní je zážitek, ne riziko — při mrazech nebo ledovce přepínáme na indoor+outdoor mix.",
    answerDetail: [
      "Zimní trasa vede nižšími partiemi Ještědského hřbetu. Cíl zůstává Ještěd — v zimě je finish pod vysílačem v mlze nejsilnější moment roku.",
      "Součástí je teplý finish drink a rychlý transport zpět do vyhřátého Warehouse.",
    ],
    sections: [
      {
        kicker: "ZIMNÍ VARIANTA",
        heading: "Co se v zimě mění",
        list: [
          "Kratší outdoorová část (cca 2,5–3 h místo 3,5 h)",
          "Trasa nižšími partiemi, mimo exponovaný hřeben",
          "Teplý finish drink a rychlý sestup",
          "Delší večerní program ve Warehouse",
          "Indoor backup pro mráz a ledovku",
        ],
        paras: [],
      },
      {
        kicker: "VYBAVENÍ",
        heading: "Zimní checklist",
        paras: [
          "Zimní obuv, teplá bunda, čepice, rukavice a termo vrstva. Přesný checklist podle předpovědi rozešleme před akcí.",
          "Zima je nejlevnější sezóna pro termíny — a vánoční teambuilding v prosinci má vlastní stránku.",
        ],
      },
    ],
    faq: [
      { q: "Není zimní mise nebezpečná?", a: "Ne — trasa se v zimě přizpůsobí: kratší, níž, mimo ledovku. Při extrémním počasí přepínáme na indoor+outdoor mix. Bezpečnostní protokol je neměnný." },
      { q: "Jak dlouho je tým venku?", a: "Zimní outdoorová část trvá cca 2,5–3 hodiny. Zbytek programu je v teple Warehouse." },
      { q: "Lze zimní misi spojit s vánočním večírkem?", a: "Ano — prosincová Mission 24 s vánoční večeří a party ve Warehouse je náš oblíbený formát. Termíny mizí rychle, poptávejte s předstihem." },
    ],
    related: [
      { href: "/podzimni-teambuilding", title: "Podzimní teambuilding", text: "Mlha a barvy Ještědu." },
      { href: "/bezpecnost", title: "Bezpečnost", text: "Extreme experience, safe execution." },
      { href: "/warehouse-party", title: "Warehouse party", text: "Vyhřátý soukromý klub." },
      { href: "/cenik", title: "Ceník", text: "Balíčky a orientační ceny." },
    ],
  }),
  mkIntent({
    slug: "dvoudenni-teambuilding",
    breadcrumb: "Dvoudenní teambuilding",
    overline: "DVOUDENNÍ TEAMBUILDING",
    title: "Dvoudenní teambuilding s ubytováním | Mission 24 na Ještědu",
    description: "Dvoudenní firemní teambuilding: Mission 24 = den 1 mise na Ještěd + večer Warehouse party, den 2 snídaně a check-out. Od 4 990 Kč na osobu.",
    h1: "Dvoudenní teambuilding: den první mise, noc party, ráno snídaně",
    heroSub: "Mission 24 je přesně to, co z názvu zní: 24 hodin, během kterých váš tým splní misi na Ještěd, oslaví ji v soukromém klubu a ráno se sejde u snídaně.",
    img: "dinner",
    answerQ: "Co obsahuje dvoudenní teambuilding Mission 24?",
    answerShort: "Den 1: arrival 11:00, briefing, Mission Ještěd (13:30–17:00), večeře 19:30, vyhlášení 21:00, soukromá Warehouse party 21:30–02:00. Nocleh pro celý tým. Den 2: snídaně 8:30–10:00, check-out 11:00. Od 4 990 Kč na osobu.",
    answerDetail: [
      "Dvoudenní formát je nejprodávanější — tým si odveze kompletní zážitek bez spěchu a nikdo večer neřeší cestu domů.",
      "Pro delší formát existuje Mission Weekend (2 noci, druhý program). Pro kratší jednodenní Mission (4–6 hodin).",
    ],
    sections: [
      {
        kicker: "PROČ DVA DNY",
        heading: "Jednodenní akce skončí ve chvíli, kdy začíná to nejlepší",
        paras: [
          "Tým se nespojí mezi 14. a 16. hodinou. Spojí se večer u společného stolu, u baru po misi a ráno u snídaně, kdy se probírají historky z trati.",
          "Dvoudenní formát navíc odstraní největší stres firemních akcí: kdo, kdy a jak odjíždí domů.",
        ],
        img: "warehouseParty",
      },
      {
        kicker: "POROVNÁNÍ",
        heading: "Dvoudenní vs jednodenní vs víkend",
        paras: [
          "Jednodenní Mission: 4–6 hodin, bez noclehu — pro firmy z blízkého okolí. Mission 24: plný zážitek přes noc. Mission Weekend: 2 noci a druhý program — pro offsite kombinované s prací.",
          "Detailní porovnání najdete na stránce jednodenní vs dvoudenní teambuilding.",
        ],
      },
    ],
    faq: [
      { q: "Kolik stojí dvoudenní teambuilding?", a: "Mission 24 od 4 990 Kč na osobu, minimální cena akce 129 000 Kč. Příklad: 30 lidí orientačně 169 000 Kč včetně ubytování, jídla a party." },
      { q: "Kde přesně spíme?", a: "Ubytování řešíme v ověřené kapacitě v Liberci a okolí tak, aby byl tým pohromadě. Konkrétní objekt potvrdíme v nabídce podle termínu." },
      { q: "Dá se druhý den využít pracovně?", a: "U Mission 24 je druhý den jen snídaně a check-out. Pro pracovní program druhý den zvolte Mission Weekend." },
    ],
    related: [
      { href: "/jednodenni-vs-dvoudenni-teambuilding", title: "Jednodenní vs dvoudenní", text: "Porovnání formátů." },
      { href: "/vikendovy-teambuilding", title: "Víkendový teambuilding", text: "Mission Weekend, 2 noci." },
      { href: "/teambuilding-s-ubytovanim", title: "Teambuilding s ubytováním", text: "Proč nocleh mění akci." },
      { href: "/cenik", title: "Ceník", text: "Balíčky a orientační ceny." },
    ],
  }),
  mkIntent({
    slug: "teambuilding-na-vikend",
    breadcrumb: "Teambuilding na víkend",
    overline: "TEAMBULDING NA VÍKEND",
    title: "Teambuilding na víkend | Mission Weekend na Ještědu",
    description: "Víkendový firemní teambuilding: Mission Weekend se 2 noclehy, Mission Ještěd, druhým programem a soukromou Warehouse party. Pátek až neděle.",
    h1: "Teambuilding na víkend: dva dny, kdy firma opravdu vypne",
    heroSub: "Pátek odpoledne příjezd, sobota Mission Ještěd a velká Warehouse party, neděle snídaně a odjezd. Nikdo nestráží telefon z kanceláře.",
    img: "warehouseExterior",
    answerQ: "Jak vypadá víkendový teambuilding Mission Weekend?",
    answerShort: "Dva dny a dvě noci: pátek příjezd a večerní zahájení, sobota Mission Ještěd s finišem a velkou soukromou Warehouse party, neděle snídaně a odjezd. Od 6 490 Kč na osobu.",
    answerDetail: [
      "Víkendové termíny vyhovují firmám, které nechtějí blokovat pracovní dny — a týmům, kde část lidí nemůže ve všední den.",
      "Harmonogram umíme otočit: sobota práce/workshop, neděle mise. Záleží na cíli akce.",
    ],
    sections: [
      {
        kicker: "HARMONOGRAM",
        heading: "Pátek–neděle krok za krokem",
        paras: [
          "Pátek: příjezd odpoledne, check-in, večeře a volný večer ve Warehouse. Sobota: snídaně, briefing, Mission Ještěd, finish, večeře, vyhlášení a soukromá party do 02:00. Neděle: pozdní snídaně a check-out.",
          "Druhý program na pátek nebo neděli stavíme na míru — od strategického workshopu po druhou outdoorovou výzvu.",
        ],
        img: "warehouseParty",
      },
      {
        kicker: "VÍKEND VS VŠEDNÍ DEN",
        heading: "Kdy zvolit víkend",
        paras: [
          "Víkend dává smysl, když firma nemůže uvolnit pracovní den, nebo když je akce částečně 'na vlastní čas'. Všední dny mají lepší dostupnost a klidnější trasy.",
          "U víkendových termínů doporučujeme poptat s větším předstihem — pátky a soboty mizí nejrychleji.",
        ],
      },
    ],
    faq: [
      { q: "Kolik stojí víkendový teambuilding?", a: "Mission Weekend od 6 490 Kč na osobu: 2 noci, Mission Ještěd, druhý program, catering, private Warehouse party, DJ, foto/video a 2× snídaně." },
      { q: "Musí akce být pátek–neděle?", a: "Ne. Umíme sobota–pondělí nebo libovolnou dvoudenní kombinaci přes víkend. Harmonogram sladíme s vašimi potřebami." },
      { q: "Je víkend dražší než všední den?", a: "Cena balíčku je stejná; u ubytování a dopravy se může lišit cena dodavatelů. Finální nabídka vždy ukáže rozdíl transparentně." },
    ],
    related: [
      { href: "/vikendovy-teambuilding", title: "Víkendový teambuilding", text: "Mission Weekend detail." },
      { href: "/dvoudenni-teambuilding", title: "Dvoudenní teambuilding", text: "Mission 24 — 24 hodin." },
      { href: "/cenik", title: "Ceník", text: "Balíčky a orientační ceny." },
      { href: "/mission-jested", title: "Mission Ještěd", text: "Kompletní program mise." },
    ],
  }),
  mkIntent({
    slug: "teambuilding-s-vecernim-programem",
    breadcrumb: "Teambuilding s večerním programem",
    overline: "TEAMBULDING S VEČERNÍM PROGRAMEM",
    title: "Teambuilding s večerním programem | Mission Ještěd + Warehouse",
    description: "Firemní teambuilding s večerním programem: po misi na Ještěd večeře, vyhlášení výsledků s promítáním fotografií a soukromá Warehouse party s DJ.",
    h1: "Teambuilding s večerním programem, který není jen 'volný program'",
    heroSub: "Večer má u nás strukturu: večeře u dlouhého stolu, vyhlášení výsledků s promítáním fotek z mise, pak DJ a soukromý klub do 02:00.",
    img: "dinner",
    answerQ: "Co obsahuje večerní program po Mission Ještěd?",
    answerShort: "19:30 společná večeře, 21:00 vyhlášení výsledků mise s cenami a promítáním fotografií z dne, 21:30–02:00 soukromá Warehouse party s DJ a barem. Celý klub je jen pro vaši firmu.",
    answerDetail: [
      "Vyhlášení je zlomový moment večera — týmy vidí svoje skóre a fotografie z checkpointů. Právě tehdy vznikají historky, které firma probírá měsíce.",
      "Večerní program je součást Mission 24 a Mission Weekend. K jednodenní misi ho lze přidat jako rozšíření.",
    ],
    sections: [
      {
        kicker: "STRUKTURA VEČERA",
        heading: "Večer, který má dramaturgii",
        paras: [
          "Žádné 'volný program od 19:00'. Večer graduje: večeře → vyhlášení → promítání → DJ → party. Každá fáze navazuje na misi z odpoledne.",
          "Večer umíme rozšířit o vaše interní vyhlášení, moderátora, live band nebo firemní video.",
        ],
        img: "warehouseParty",
      },
      {
        kicker: "PRIVÁTNÍ PROSTOR",
        heading: "Celý Warehouse jen pro vás",
        paras: [
          "Warehouse Liberec je náš vlastní industriální klub. Na váš večer se zavře veřejnosti — bar, DJ, světla a prostor patří jen vaší firmě.",
          "Kapacita komfortně 20–100 lidí podle konfigurace večera.",
        ],
      },
    ],
    faq: [
      { q: "Co když nechceme diskotéku?", a: "Večer ladíme podle firmy: lounge hudba, kvíz, live band nebo jen bar a posezení. DJ není povinnost — Warehouse je prostor, který přizpůsobíme." },
      { q: "Do kolika večerní program trvá?", a: "Standardně do 02:00. Harmonogram večera umíme přizpůsobit — kratší večer, dřívější vyhlášení, pozdější start." },
      { q: "Lze večerní program dokoupit k jednodenní misi?", a: "Ano. Večeře + soukromý Warehouse s DJ umíme přidat k jednodenní Mission jako rozšíření." },
    ],
    related: [
      { href: "/warehouse-party", title: "Warehouse party", text: "Soukromý klub detail." },
      { href: "/teambuilding-s-dj", title: "Teambuilding s DJ", text: "DJ a hudba na míru." },
      { href: "/teambuilding-s-party", title: "Teambuilding s party", text: "Mise + party balíček." },
      { href: "/cenik", title: "Ceník", text: "Balíčky a orientační ceny." },
    ],
  }),
  mkIntent({
    slug: "teambuilding-s-dj",
    breadcrumb: "Teambuilding s DJ",
    overline: "TEAMBULDING S DJ",
    title: "Teambuilding s DJ a soukromým klubem | Warehouse Liberec",
    description: "Firemní teambuilding s DJ: po Mission Ještěd soukromá Warehouse party s profesionálním DJ, barem a ozvučením. Hudba na míru vaší firmě.",
    h1: "Teambuilding s DJ: váš playlist, náš klub, žádní cizí lidé",
    heroSub: "Profesionální DJ, klubové ozvučení a světla ve Warehouse Liberec. Před akcí od vás vezmeme muzikální preference — večer zní jako vaše firma.",
    img: "warehouseParty",
    answerQ: "Jak funguje teambuilding s DJ ve Warehouse?",
    answerShort: "Součástí balíčků Mission 24 a Mission Weekend je privátní Warehouse party 21:30–02:00 s profesionálním DJ a barem. DJ konzultuje hudební preference před akcí — od korporátního popu po drum&bass.",
    answerDetail: [
      "Warehouse je náš vlastní klub, takže DJ, světla i ozvučení jsou standard — ne pronajaté řešení na jednu noc.",
      "Jako upsell nabízíme live band místo DJ nebo kombinaci: kapela první část večera, DJ do konce.",
    ],
    sections: [
      {
        kicker: "HUDBA",
        heading: "Playlist na míru, ne generický wedding mix",
        paras: [
          "Před akcí si vyžádáme hudební preference firmy: co se poslouchá v kanceláři, co nesmí znít a jaký má být konec večera. DJ s tím pracuje celý večer.",
          "Vyhlášení výsledků mise ve 21:00 má vlastní zvukovou a světelnou produkci — není to jen přečtení tabulky.",
        ],
        img: "warehouseExterior",
      },
      {
        kicker: "TECHNIKA",
        heading: "Klubové zázemí",
        list: [
          "Profesionální ozvučení a světelný park",
          "Promítání fotografií z mise na plátně",
          "Bar s obsluhou celý večer",
          "Prostor pro 20–100 lidí",
        ],
        paras: [],
      },
    ],
    faq: [
      { q: "Můžeme si vybrat styl hudby?", a: "Ano. Před akcí konzultujeme preference — DJ připraví set podle vaší firmy a večer čte publikum." },
      { q: "Umíte i live band?", a: "Ano, jako upsell. Kapela může hrát první část večera a DJ pokračuje do 02:00." },
      { q: "Je DJ součástí každého balíčku?", a: "DJ je v ceně Mission 24 a Mission Weekend. K jednodenní misi lze večerní Warehouse s DJ dokoupit." },
    ],
    related: [
      { href: "/warehouse-party", title: "Warehouse party", text: "Soukromý klub detail." },
      { href: "/teambuilding-s-vecernim-programem", title: "Večerní program", text: "Večeře, vyhlášení, party." },
      { href: "/teambuilding-s-party", title: "Teambuilding s party", text: "Mise + party." },
      { href: "/cenik", title: "Ceník", text: "Balíčky a orientační ceny." },
    ],
  }),
  mkIntent({
    slug: "teambuilding-s-cateringem",
    breadcrumb: "Teambuilding s cateringem",
    overline: "TEAMBULDING S CATERINGEM",
    title: "Teambuilding s cateringem | Mission Ještěd — jídlo v ceně",
    description: "Firemní teambuilding s cateringem: Mission 24 zahrnuje lunch/snack, společnou večeři a snídani. Diety a alergie vyřešíme předem. Premium catering jako upsell.",
    h1: "Teambuilding s cateringem: nikdo nehlídá čas oběda, nikdo nehladoví",
    heroSub: "Lunch po příjezdu, snack na trati, večeře u dlouhého stolu, snídaně po party. Stravování je součást balíčku — ne položka, kterou řešíte zvlášť.",
    img: "dinner",
    answerQ: "Jaké stravování je v ceně teambuildingu Mission 24?",
    answerShort: "Mission 24 zahrnuje lunch/snack po příjezdu, společnou večeři po misi a snídani druhý den ráno. Dietní omezení (vegetariánské, veganské, bezlepkové, alergie) vyřešíme předem — stačí je uvést v poptávce.",
    answerDetail: [
      "Večeře je společná u dlouhého stolu ve Warehouse — je to součást dramaturgie dne, ne bufet v rohu.",
      "Premium catering (rozšířené menu, živá stanoviště, výběrové suroviny) nabízíme jako upsell.",
    ],
    sections: [
      {
        kicker: "CO KDY",
        heading: "Jídlo v harmonogramu mise",
        list: [
          "11:00–12:00 arrival — lehké občerstvení a káva",
          "Během mise — snack a voda v Mission Packu",
          "19:30 společná večeře",
          "Večer — bar v rámci Warehouse party (open bar jako upsell)",
          "8:30–10:00 snídaně",
        ],
        paras: [],
      },
      {
        kicker: "DIETY",
        heading: "Alergie a diety bez trapasu",
        paras: [
          "Stravovací omezení sbíráme v koordinační fázi před akcí — každý účastník dostane svoji variantu bez dohadování na místě.",
          "Večeře i snídaně mají standardně vegetariánskou variantu; bezlepek a alergie řešíme individuálně.",
        ],
      },
    ],
    faq: [
      { q: "Je v ceně i pití?", a: "Voda a snack na trati ano. Večerní bar je konzumace na účet akce v rámci balíčku ve vybraném rozsahu — open bar (neomezeně) je upsell." },
      { q: "Zvládnete bezlepkovou dietu pro část týmu?", a: "Ano. Diety a alergie nám nahlaste před akcí v koordinační schůzce — kuchyně je připravena." },
      { q: "Co je premium catering?", a: "Rozšířené menu s živými stanovišti a výběrovými surovinami — vhodné pro management offsite nebo výročí firmy. Cenu nabídneme v kalkulaci." },
    ],
    related: [
      { href: "/teambuilding-s-vecernim-programem", title: "Večerní program", text: "Večeře, vyhlášení, party." },
      { href: "/teambuilding-s-ubytovanim", title: "Teambuilding s ubytováním", text: "Kompletní balíček." },
      { href: "/cenik", title: "Ceník", text: "Balíčky a orientační ceny." },
      { href: "/mission-jested", title: "Mission Ještěd", text: "Kompletní program mise." },
    ],
  }),
];
